import axios from 'axios'
import {browserHistory} from 'react-router'
import {pendingTask, begin, end} from 'react-redux-spinner'
import {
  AUTH_USER_REQUEST,
  AUTH_USER,
  AUTH_ERROR,
  UNAUTH_USER,
  FETCH_MESSAGE,
} from './types'

export function signinUserRequest() {
  const data = {
    loading: true,
  }
  return {
    type: AUTH_USER_REQUEST,
    [pendingTask]: begin,
    payload: data,
  }
}

export function signinUser({email, password}) {
  return function(dispatch) {
    dispatch(signinUserRequest())
    axios
      .post(`${process.env.REACT_APP_EF_API_URL}/signin`, {email, password})
      .then(response => {
        dispatch({type: AUTH_USER, [pendingTask]: end})
        localStorage.setItem('token', response.data.token)
        browserHistory.push('/dashboard')
      })
      .catch(() => {
        dispatch(authError('Bad login info'))
      })
  }
}

export function signupUser({email, password}) {
  return function(dispatch) {
    dispatch(signinUserRequest())
    axios
      .post(`${process.env.REACT_APP_EF_API_URL}/signup`, {email, password})
      .then(response => {
        dispatch({type: AUTH_USER, [pendingTask]: end})
        localStorage.setItem('token', response.data.token)
        browserHistory.push('/dashboard')
      })
      .catch(response => dispatch(authError('Bad signup info')))
  }
}

export function authError(error) {
  return {
    type: AUTH_ERROR,
    [pendingTask]: end,
    payload: error,
  }
}

export function signoutUser() {
  localStorage.removeItem('token')
  return {
    type: UNAUTH_USER,
  }
}

export function fetchMessage() {
  return function(dispatch) {
    axios
      .get(process.env.REACT_APP_EF_API_URL, {
        headers: {authorization: localStorage.getItem('token')},
      })
      .then(response => {
        dispatch({
          type: FETCH_MESSAGE,
          payload: response.data.message,
        })
      })
  }
}

// Redux promises version, need to go back are re-work if I want to use
// export function fetchMessage() {
//   const request = axios.get(API_URL, {
//     headers: { authorization: localStorage.getItem('token') }
//   });
//
//   return {
//     type: FETCH_MESSAGE,
//     payload: request
//   }
// }



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/